import { supabase } from "../supabase";


export const  taskerBankAccounts = (taskerId: number) => {
return supabase
        .from('tasker_bank_accounts')
        .select('*')
        .eq('tasker_id', taskerId)
        .single();
}